var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBedroom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.15 4.21484V10.5398M3.84998 4.21484V10.5398V4.21484Z",
    stroke: "#8B8C9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84998 6.59898C6.32498 5.22398 11 1.83231 18.15 6.59898",
    stroke: "#8B8C9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 15.5837V10.9087C18.2416 11.367 16.5916 10.9087 12.65 10.0837C9.89997 9.44202 8.24997 10.267 6.32497 10.9087C4.76663 11.4587 3.02497 11.092 2.3833 10.9087V15.5837H19.8Z",
    stroke: "#8B8C9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66663 15.8594V17.9677",
    stroke: "#8B8C9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 15.8594V17.9677",
    stroke: "#8B8C9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedroom);
export default __webpack_public_path__ + "static/media/bedroom.4fc7cbf9.svg";
export { ForwardRef as ReactComponent };